import { setButtonLoadingState } from "./buttons";
import { addErrorNotice } from "./notices";

interface AuthResponse {
  methods: string[];
}

async function continueHandler(ev: MouseEvent) {
  ev.preventDefault();

  const emailInput = document.getElementById("email");
  const continueButton = document.getElementById("continue-button");

  if (!emailInput || !continueButton) {
    return;
  }

  const email = (emailInput as HTMLInputElement).value;
  if (email.length === 0) {
    return;
  }

  const cancelLoadingState = setButtonLoadingState(
    continueButton as HTMLButtonElement,
    "Checking...",
  );

  try {
    const response = await fetch("/signin/api/auth", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
      }),
    });

    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const json = (await response.json()) as AuthResponse;
    cancelLoadingState();

    if (json.methods) {
      if (
        json.methods.includes("email") &&
        !json.methods.includes("password")
      ) {
        setFormEmailAuth();
        return;
      }

      if (json.methods.includes("password")) {
        setFormPasswordAuth();
        return;
      }
    }
  } catch (err) {
    console.error(err);
    cancelLoadingState();
    addErrorNotice("Error checking available authentication methods.");
  }
}

async function sendEmailHandler(ev: MouseEvent) {
  ev.preventDefault();

  const emailInput = document.getElementById("email");
  const emailAuthButton = document.getElementById("email-auth-button");
  const redirectUriInput = document.getElementById("redirect-uri");

  if (!emailInput) {
    return;
  }

  const email = (emailInput as HTMLInputElement).value;
  if (email.length === 0) {
    return;
  }

  const cancelLoadingState = setButtonLoadingState(
    emailAuthButton as HTMLButtonElement,
    "Sending...",
  );

  try {
    const response = await fetch("/signin/api/email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
      }),
    });

    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    cancelLoadingState();

    const query = new URLSearchParams();
    query.append("e", email);

    if (redirectUriInput) {
      const value = (redirectUriInput as HTMLInputElement).value;
      if (value) {
        query.append("r", value);
      }
    }

    window.location.replace(`/signin/email/verify?${query.toString()}`);
  } catch (err) {
    console.error(err);
    cancelLoadingState();
    addErrorNotice("Error sending verification email.");
  }
}

function resetForm() {
  const continueForm = document.getElementById("continue-form");
  const emailAuthForm = document.getElementById("email-auth-form");
  const passwordAuthForm = document.getElementById("password-auth-form");

  if (continueForm && emailAuthForm && passwordAuthForm) {
    continueForm.classList.add("hidden");
    emailAuthForm.classList.add("hidden");
    passwordAuthForm.classList.add("hidden");
  }

  const continueButton = document.getElementById("continue-button");
  const emailAuthSendButton = document.getElementById("email-auth-send-button");

  if (continueButton) {
    continueButton.removeEventListener("click", continueHandler);
  }

  if (emailAuthSendButton) {
    emailAuthSendButton.removeEventListener("click", sendEmailHandler);
  }
}

function setFormContinue() {
  resetForm();

  const continueForm = document.getElementById("continue-form");
  const continueButton = document.getElementById("continue-button");

  if (continueForm && continueButton) {
    continueForm.classList.remove("hidden");
    continueButton.addEventListener("click", continueHandler);
  }
}

function setFormEmailAuth() {
  resetForm();

  const emailAuthForm = document.getElementById("email-auth-form");
  const emailAuthButton = document.getElementById("email-auth-button");

  if (emailAuthForm && emailAuthButton) {
    emailAuthForm.classList.remove("hidden");
    emailAuthButton.addEventListener("click", sendEmailHandler);
  }
}

function setFormPasswordAuth() {
  resetForm();

  const authForm = document.getElementById("auth-form");
  const passwordAuthForm = document.getElementById("password-auth-form");

  if (authForm) {
    (authForm as HTMLFormElement).action = "/signin/password";
  }

  if (passwordAuthForm) {
    passwordAuthForm.classList.remove("hidden");
  }
}

export function activateAuthForm() {
  setFormContinue();
}
